module.exports = __webpack_public_path__ + "static/media/crew.6eb2d5da.svg";